// KO slow-mo. trigger() ramps timeScale 1 → koSlowMoScale → 1 over a window.
import { CONFIG } from '../config';

export class SlowMo {
  private t = -1;
  private inS = CONFIG.fx.koSlowMoIn / 1000;
  private holdS = CONFIG.fx.koSlowMoHold / 1000;
  private outS = CONFIG.fx.koSlowMoOut / 1000;

  trigger(): void { this.t = 0; }
  step(realDt: number): void { if (this.t >= 0) this.t += realDt; }
  reset(): void { this.t = -1; }

  factor(): number {
    if (this.t < 0) return 1;
    const total = this.inS + this.holdS + this.outS;
    if (this.t >= total) { this.t = -1; return 1; }
    const target = CONFIG.fx.koSlowMoScale;
    if (this.t < this.inS) {
      const a = this.t / this.inS;
      return 1 + (target - 1) * smooth(a);
    } else if (this.t < this.inS + this.holdS) {
      return target;
    } else {
      const a = (this.t - this.inS - this.holdS) / this.outS;
      return target + (1 - target) * smooth(a);
    }
  }
}

function smooth(x: number): number { return x * x * (3 - 2 * x); }
